var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job-search-input"},[_c('input',{staticClass:"border",attrs:{"type":"search","name":"search","placeholder":_vm.$t('search'),"readonly":_vm.readonly},on:{"keyup":_vm.handleChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }